import Svg from '@app/components/svg';

const ActionsDots = Svg(
  <path
    d="M 8 12 C 9.106 12 10 12.896 10 14 C 10 15.104 9.106 15.998 8 15.998 C 6.896 15.998 6 15.104 6 14 C 6 12.896 6.896 12 8 12 M 8 6 C 9.106 6 10 6.894 10 8 C 10 9.106 9.106 10 8 10 C 6.896 10 6 9.106 6 8 C 6 6.894 6.896 6 8 6 M 8 0 C 9.106 0 10 0.896 10 2 C 10 3.106 9.106 4 8 4 C 6.896 4 6 3.106 6 2 C 6 0.896 6.896 0 8 0 Z"
    fill="currentColor"
  />,
  {
    viewBox: '0 0 16 16',
  },
);

ActionsDots.displayName = 'ActionsDots';

export default ActionsDots;
